import useReveal from "@/hooks/useReveal";
import { method } from "@/lib/home-content";

function Step({ step, i }) {
    const { ref, visible } = useReveal();
    return (
        <div
            ref={ref}
            data-testid={`process-chapter-${step.no}`}
            style={{ transitionDelay: `${i * 80}ms` }}
            className={`reveal relative rounded-3xl bg-white p-6 shadow-[0_12px_36px_rgba(15,23,42,0.06)] ring-1 ring-black/5 ${
                visible ? "is-visible" : ""
            }`}
        >
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[var(--brand-soft)] font-display text-lg font-extrabold text-[var(--brand)]">
                {step.no}
            </div>
            <h3 className="font-display text-lg font-bold text-[#0a0a0b]">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#5b5b66]">{step.desc}</p>
        </div>
    );
}

export default function HowItWorks() {
    const { ref, visible } = useReveal();
    return (
        <section id="process" data-testid="how-it-works-section" className="bg-white px-5 py-14 sm:py-20">
            <div className="mx-auto max-w-5xl">
                <div ref={ref} className={`reveal mb-9 text-center ${visible ? "is-visible" : ""}`}>
                    <span className="rounded-full bg-[var(--brand-soft)] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[var(--brand)]">
                        {method.kicker}
                    </span>
                    <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-[#0a0a0b] sm:text-4xl">
                        {method.title}
                    </h2>
                    <p className="mx-auto mt-3 max-w-xl text-[15px] leading-relaxed text-[#5b5b66]">
                        {method.subtitle}
                    </p>
                </div>
                <div className="grid gap-5 sm:grid-cols-2">
                    {method.steps.map((s, i) => (
                        <Step key={s.no} step={s} i={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
